/* home-custom.js
 * ShopFAll() extracted from newho's custom.js.
 * The homepage sections (shoppable-media-grid, media-grid-mobile, tab-slider)
 * call ShopFAll() inline at parse time, so it must be defined synchronously.
 * Only this function is ported: newho's full custom.js also attaches global
 * handlers and ends in an unguarded querySelector(...).innerHTML that throws
 * a TypeError on every page without the Judge.me review widget.
 */

function ShopFAll() {
    document.querySelectorAll('.shop_all_btn').forEach(function(shopAll) {
        shopAll.addEventListener('click', function() {
            var items = [];
            var i;
            var ids = shopAll.getAttribute('data-id').split(',');
            for (i = 0; i <= ids.length; i++) {
                var id = ids[i];
                var ID = parseInt(id);
                if (ID) {
                    items.push({
                        id: ID,
                        quantity: 1
                    });
                }
            }
            console.log(items);
            let formData = {
                'items': items
            };

            fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                })
                .then(data => {
                    window.location.href = '/cart';
                }).catch(error => {
                    console.error('Error adding item to cart:', error);
                });
        });
    });

    $('#modal-close').click(function() {
        $('#modal-container').removeClass('two');
        $('body').removeClass('modal-active');
    });
}
